module.exports = __webpack_public_path__ + "ir.da2cf31ccb56f2c85d2f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ir.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ir.svg
// module chunks = styles